// Exact historical defaults; persistence ID intentionally unchanged.
export const internalToolsLegacy = {
    id: 'bz-telecom-cyberops-pmbot',
    title: 'BZ Telecom, CyberOps, PMBot et outils tactiques',
    family: 'Opérations',
    importance: 'moyenne',
    ownerIds: ['rd', 'ed', 'jp', 'fm'],
    tags: ['BZ Telecom', 'CyberOps', 'PMBot', 'outils', 'tactique'],
    summary: 'Faire l’inventaire des outils tactiques et décider lesquels deviennent officiels, expérimentaux ou à retirer.',
    whyNow: 'Plusieurs outils existent ou sont nommés. Sans statut clair, ils créent de la confusion au lieu d’aider.',
    enrichedContext: ['PRIsME contient une page BZ Telecom et des traces CyberOps.', 'TactiCE contient des traces CyberOps, telecom et SAC.', 'AIKUB/PRIsME doivent éviter la multiplication des outils non gouvernés.'],
    questions: ['Quels outils sont utilisés chaque semaine?', 'Quels outils sont encore prototypes?', 'Quel outil devient source de vérité pour quoi?'],
    decisions: ['Classer outils : officiel / pilote / à retirer.', 'Nommer owner par outil.', 'Définir prochain cleanup.'],
    signals: ['Outils mentionnés dans screenshot.', 'CyberOps ressort dans PRIsME/TactiCE.', 'Besoin de gouvernance d’outillage.'],
    evidence: ['PRIsME BZTelecom', 'CyberOps search matches', 'TactiCE telecom matches'],
    position: { x: 80, y: 82, rotate: 2 },
};
